import React from 'react';

import { bemBlock } from '../../modules/bem';
import { Padding } from '../../modules/layout';
import { Layout } from '../layout/Layout';
import { LayoutRowProps } from '../layout-row/LayoutRow';

import './CardSection.less';

const block = bemBlock('n-card-section');

export type CardSectionProps = {
  className?: string;
  children?: React.ReactNode;
  withPadding?: Padding;
};

const DEFAULT_PADDING: Padding = ['md', 'lg'];

export const CardSection: React.FC<
  CardSectionProps & Omit<LayoutRowProps<{}>, 'spacedChildren' | 'withPadding'>
> = ({ className, children, withPadding = DEFAULT_PADDING, ...rest }) => {
  return (
    <Layout.Row
      className={block({ extra: className })}
      {...rest}
      withPadding={withPadding}
      spacedChildren="md"
    >
      {children}
    </Layout.Row>
  );
};
